// src/pages/UmatListNav.js
import React from "react";
import { Link } from "react-router-dom";
import FormLayout from "../layouts/FormLayout";
import { isZh } from "../utils/language";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ICONS: {hostname}/iconspreview.html

function encodeFilterID(filterID) {
  return encodeURIComponent(filterID);
}

export default function UmatListNav() {
  // DATA: setiap item sekarang objek { label, filterID }
  const groups = [
    {
      id: "kelasPembahasan",
      title: isZh() ? "所屬區域" : "Kelas Pembahasan",
      iconSrc: "https://unpkg.com/heroicons@2.0.16/24/outline/book-open.svg",
      items: [
        { label: isZh() ? "禮恩" : "Li En", filterID: "ALE" },
        { label: isZh() ? "淨化" : "Jing Hua", filterID: "AJH" },
        { label: isZh() ? "展道" : "Zhan Dao", filterID: "AZD" },
        { label: isZh() ? "展信" : "Zhan Xin", filterID: "AZX" },
        { label: isZh() ? "禮慈" : "Li Ci", filterID: "ALC" },
        { label: isZh() ? "德化" : "De Hua", filterID: "ADH" },
      ],
    },
/*  {
      id: "luarKota",
      title: "Luar Kota",
      iconSrc: "https://unpkg.com/heroicons@2.0.16/24/outline/globe-americas.svg",
      items: [
        { label: "Zhan Cheng Pringsewu", filterID: "AZC" },
        { label: "Zhan Lian, Pangkal Pinang", filterID: "AZL" },
        { label: "Zhan Zhong, Sungai Liat", filterID: "AZZ" },
        { label: "Miao Shan, Solo", filterID: "AMS" },
      ],
    },
  */
    {
      id: "kelasRutin",
      title: isZh() ? "常規班級" : "Kelas Rutin",
      iconSrc: "https://unpkg.com/heroicons@2.0.16/24/outline/users.svg",
      items: [
        { label: isZh() ? "長青班" : "Usia Indah", filterID: "changqing" },
        { label: isZh() ? "慈化青年" : "Muda-Mudi CiQing", filterID: "ciqing" },
        { label: isZh() ? "成長班" : "SMP ChengZhang", filterID: "chengzhang" },
        { label: isZh() ? "兒童班" : "Paritta Anak-anak", filterID: "ertong" },
      ],
    },
    {
      id: "dutyLevel",
      title: isZh() ? "天職" : "Duty Level",
      iconSrc: "https://unpkg.com/heroicons@2.0.16/24/outline/shield-check.svg",
      items: [
        { label: isZh() ? "講師" : "Jiang Shi", filterID: "JiangShi" },
        { label: isZh() ? "講員" : "Jiang Yuan", filterID: "JiangYuan" },
        { label: isZh() ? "壇主" : "Tan Zhu", filterID: "TanZhu" },
        { label: isZh() ? "清口幹部" : "Kader Qing Kou", filterID: "QingKou" },
        { label: isZh() ? "辦事員（三天法會）" : "Petugas (sudah SD 3 Hari)", filterID: "BanShi" },
      ],
    },
    {
      id: "admin",
      title: isZh() ? "行政管理" : "Pengelolaan Administrasi",
      iconSrc: "https://unpkg.com/heroicons@2.0.16/24/outline/shield-check.svg",
      items: [
        { label: isZh() ? "區域未設" : "Belum ada Area", filterID: "NoArea" },
        { label: isZh() ? "照片未設" : "Belum ada Foto", filterID: "NoPhoto" },
        //{ label: isZh() ? "新求道" : "Umat Baru", filterID: "QiuDaoBaru" },
        //{ label: isZh() ? "新三天班" : "Baru SD 3 Hari", filterID: "SD3HBaru" },
      ],
    },
  ];

  return (
    <FormLayout title={isZh() ? "團體與社群" : "Grup dan Komunitas"}>
      {/* Inline CSS for this page (ke dalam file yang sama) */}
      <style>
        {`
          /* Container */
          .uln-container {
            max-width: 1120px;
            margin: 0 auto;
            padding: 28px 16px;
            box-sizing: border-box;
            color: #0f172a;
            font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
          }

          .uln-title {
            font-size: 28px;
            font-weight: 700;
            margin: 0 0 8px 0;
            color: #0f172a;
          }

          .uln-sub {
            margin: 0 0 18px 0;
            color: #475569;
            font-size: 14px;
          }

          /* Grid: responsive */
          .uln-grid {
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(1, 1fr);
          }
          @media (min-width: 640px) { /* small screens and up */
            .uln-grid { grid-template-columns: repeat(2, 1fr); }
          }
          @media (min-width: 900px) { /* medium */
            .uln-grid { grid-template-columns: repeat(3, 1fr); }
          }
          @media (min-width: 1100px) { /* large */
            .uln-grid { grid-template-columns: repeat(4, 1fr); }
          }

          /* Card */
          .uln-card {
            background: #ffffff;
            border: 1px solid #e6eef6;
            border-radius: 14px;
            padding: 16px;
            box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
            box-sizing: border-box;
          }

          .uln-card-header {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
          }

          .uln-icon-box {
            width: 36px;
            height: 36px;
            min-width: 36px;
            border-radius: 8px;
            background: #f8fafc;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            color: #0f172a;
          }

          .uln-icon-box img {
            width: 20px;
            height: 20px;
            display: block;
          }

          .uln-card-title {
            font-size: 16px;
            font-weight: 600;
            color: #0f172a;
            margin: 0;
          }

          /* item list */
          .uln-list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: block;
          }

          .uln-list-item {
            margin-bottom: 8px;
          }

          .uln-link {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 12px;
            border-radius: 8px;
            text-decoration: none;
            color: #0f172a;
            background: transparent;
            transition: background 120ms ease, transform 120ms ease;
            box-sizing: border-box;
          }
          .uln-link:hover {
            background: #f8fafc;
            transform: translateY(-1px);
          }

          .uln-link-left {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .uln-bullet {
            width: 10px;
            height: 10px;
            min-width: 10px;
            border-radius: 999px;
            background: #94a3b8;
            display: inline-block;
          }
            
            .uln-item-label {
            font-size: 15px;
            font-weight: 500;
            color: #0f172a;
            white-space: normal;       /* dulu: nowrap */
            overflow: visible;          /* dulu: hidden */
            text-overflow: unset;       /* dulu: ellipsis */
            max-width: 100%;            /* dulu: 80% */
            line-height: 1.3;
            }

          .uln-chevron {
            width: 18px;
            height: 18px;
            opacity: 0.65;
            flex-shrink: 0;
          }

          /* footer info */
          .uln-footer {
            margin-top: 18px;
            font-size: 13px;
            color: #475569;
          }

          .uln-code {
            background: #f1f5f9;
            padding: 3px 8px;
            border-radius: 6px;
            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, "Roboto Mono", "Helvetica Neue", monospace;
            font-size: 13px;
            color: #0f172a;
          }

          .btn-submit { display:none;}
          .form-info-row, .form-top-actions {display:none;}
          .form-body {padding-top:0}
        `}
      </style>

      <div className="uln-container">
        <p className="uln-sub">
          {isZh()
            ? "請選擇選單以查看道親名單。"
            : "Pilih menu untuk melihat daftar umat."}
        </p>

        <div className="uln-grid" role="list">
          {groups.map((g) => (
            <section key={g.id} aria-labelledby={g.id} className="uln-card">
              <div className="uln-card-header">
                <div className="uln-icon-box" aria-hidden="true">
                  <img src={g.iconSrc} alt={`${g.title} icon`} />
                </div>
                <h2 id={g.id} className="uln-card-title">
                  {g.title}
                </h2>
              </div>

              <ul className="uln-list">
                {g.items.map((item) => (
                  <li className="uln-list-item" key={item.filterID}>
                    <Link
                      className="uln-link"
                      to={`/UmatList?filter=${encodeFilterID(item.filterID)}`}
                    >
                      <div className="uln-link-left">
                        <span className="uln-bullet" aria-hidden="true" />
                        <span className="uln-item-label" title={item.label}>
                          {item.label}
                        </span>
                      </div>

                      {/* chevron (inline svg) */}
                      <svg
                        className="uln-chevron"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M9 6l6 6-6 6"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke="#475569"
                        />
                      </svg>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="uln-footer">
          <div style={{ marginTop: 6 }}>
          </div>
        </div>
      </div>
    </FormLayout>
  );
}
